import React from 'react';

export const TranslatedLayoutIcon = (props: React.ComponentPropsWithoutRef<'svg'>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="4 2.8 12 12.5" {...props}>
    <path
      fill="currentColor"
      d="M5.275 14.725a.525.525 0 0 1-.525-.525V5.8a.525.525 0 0 1 .525-.525h9.45a.525.525 0 0 1 .525.525v8.4a.525.525 0 0 1-.525.525h-9.45Zm2.1-5.775H5.8v4.725h1.575V8.95Zm6.825 0H8.425v4.725H14.2V8.95Zm0-2.625H5.8V7.9h8.4V6.325Z"
    />
    <path
      fill="url(#a)"
      stroke="#fff"
      strokeWidth=".75"
      d="M12.055 2.824v.632h2.01v1.38h-.777a6.044 6.044 0 0 1-.928 1.56c.136.096.276.187.422.268l.217.12.512-1.205.097-.228h1.166l.097.228 1.475 3.474.22.521H15.03l-.097-.228-.305-.719h-.873l-.305.719-.098.228h-1.536l.222-.521.417-.987-.283-.151a6.106 6.106 0 0 1-.827-.532 6.075 6.075 0 0 1-1.971.999l-.36.106-.106-.36-.18-.608-.105-.359.357-.107a4.66 4.66 0 0 0 1.347-.657 6.037 6.037 0 0 1-.736-1.136l-.21-.424h-.756V3.456h2.01v-.632h1.42Zm-1.053 2.083c.102.178.217.348.343.512.142-.185.268-.38.38-.582h-.764l.041.07Z"
    />
    <defs>
      <linearGradient id="a" x1="16" x2="10.071" y1="3.199" y2="10.117" gradientUnits="userSpaceOnUse">
        <stop offset=".232" stopColor="#FF884D" />
        <stop offset=".802" stopColor="#E300BD" />
      </linearGradient>
    </defs>
  </svg>
);
